<template>
  <div id="app" :class="[$store.state.isWeixin ? 'is-wx' : 'is-web']">
    <component :is="layout"></component>
    <div class="mask" v-if="mask" @click="mask = false">
      <share-icon class="icon"/>
      <div class="mark-tips">
        <p>点击右上角...</p>
        <p>可以分享给其他家长哦~</p>
      </div>
    </div>
  </div>
</template>
<script>
import Main from '@/layouts/Main'
import Minor from '@/layouts/Minor'
import Noop from '@/layouts/Noop'
import ShareIcon from '@/assets/svg/icon_share.svg'

export default {
  data() {
    return {
      innerHeight: (window.innerHeight / 375) * 100,
      mask: false
    }
  },
  computed: {
    layout() {
      switch (this.$route.meta.layout) {
        case 'main':
          return Main
        case 'minor':
          return Minor
        default:
          return Noop
      }
    }
  },
  mounted() {
    setTimeout(this.checkMaskStatus, 500)
  },
  methods: {
    checkMaskStatus() {
      if (!sessionStorage.getItem('shareTipsShowed')) {
        this.mask = true
        sessionStorage.setItem('shareTipsShowed', true)
      }
    }
  },
  components: {
    ShareIcon
  }
}
</script>
<style lang="stylus" scoped>
.mask
  position fixed
  display block
  z-index 100
  width 100%
  height 100%
  top 0
  left 0
  background-color rgba(0, 0, 0, 0.7)
  .icon
    position fixed
    right 25px
    top 25px
    width 105px
    height 113px
.mark-tips
  font-size 18px
  color white
  margin-top 150px
  margin-left 93px
</style>
